import { useAuthStore } from "src/context/authStore";

export function useIsAdmin(): boolean {
  return useAuthStore((state) => state.isAdmin);
}
